export default "__VITE_ASSET__BakGALhr__"